import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { RecallReceivedReceiptListInterface } from "../../../../../redux/interfaces/recall.interface";
import { dateToString, getDateAndTime } from "../../../../../utils/dateAndTime";

export const recallClientReceiptsTableHeader: TableHeaderCategoryConfig[] = [
  { value: "productCode", label: "Cod produs", minW: 130 },
  { value: "lot", label: "Lot", minW: 130 },
  { value: "bbd", label: "Data expirare (BBD)", minW: 150 },
  { value: "cantitate_cutie", label: "Cantitate cutie", minW: 140 },
  { value: "cantitate_fractie", label: "Cantitate fractie", minW: 140 },
  { value: "lastReceiptAt", label: "Ultima primire", minW: 170 },
];

export const getRecallClientReceiptsTableData = (
  data: RecallReceivedReceiptListInterface[],
): TableData[] =>
  data.map((receipt) => ({
    id: receipt.idRecallLine,
    crudData: receipt,
    data: [
      { title: receipt.productCode },
      { title: receipt.lot },
      { title: dateToString(receipt.bbd) },
      { title: receipt.cantitate_cutie },
      { title: receipt.cantitate_fractie },
      { title: getDateAndTime(receipt.lastReceiptAt) },
    ],
  }));
